module.exports = __webpack_public_path__ + "img/mvp_default_headimage.d7e19c47.png";